var default_styles_default = {
  "button_container": "ktXAd",
  "button_margin": "PhTNk",
  "button_text": "_8ORd0",
  "button_size_content": "d7k4k"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
